export default __webpack_public_path__ + "static/media/webapp-overlay-loader.a54056f4.gif";